import React from 'react';
import backgroundImg from '../../../assets/images/educational_service/edu_form_bg.jpg';
import GradientButton from '../../../components/atoms/GradientButton';
import agreementService from '../../../assets/documents/Education - Agreement of Services_06062025.pdf';
import { openPdf } from '../../../utils/hooks/utils';
import feeSchedule from '../../../assets/documents/Education Services Fee Schedule_06062025.pdf';
import educationRegistration from '../../../assets/documents/Educational Registration_06062025.pdf';

function EducationalForm() {
  return (
    <div>
      <div
        className="w-full bg-cover bg-center bg-no-repeat flex"
        style={{
          backgroundImage: `url(${backgroundImg})`,
        }}
      >
        <div className="w-full flex flex-col lg:flex-row items-center justify-between max-w-[1238px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-30 gap-20">
          <div className="w-full flex-row justify-items-start">
            <h1 className="text-[30px] md:text-[35px] lg:text-[45px] text-primary font-bold mb-8">
              Educational Services Forms
            </h1>
            <div className="mb-8 sm:mb-12">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-6">
                <GradientButton
                  text="Agreement of Services"
                  isDark={false}
                  onClick={() => openPdf(agreementService)}
                />
                <GradientButton
                  text="Educational Fee Schedule"
                  isDark={false}
                  onClick={() => openPdf(feeSchedule)}
                />
                <GradientButton
                  text="Educational Registration"
                  isDark={false}
                  onClick={() => openPdf(educationRegistration)}
                />
              </div>
            </div>
            <div className="flex flex-col gap-6 text-[#555859] text-xl font-[500]">
              <article>
                <h1 className="text-[30px] md:text-[35px] lg:text-[45px] text-primary font-bold mb-4">
                  Come see us today!
                </h1>
                <p>Guidepost Pediatric Therapies and Educational Services</p>
              </article>

              <div className="flex flex-col">
                <h1 className="text-[25px] md:text-[35px] lg:text-[45px] text-primary font-bold mb-4">
                  Location
                </h1>
                <p>
                  1174 N Leatherleaf Loop Unit D <br /> Wasilla, AK 99654
                </p>
              </div>
              <div className="flex flex-col ">
                <h1 className="text-xl lg:text-[28px] text-primary font-bold mb-4">
                  Hours
                </h1>
                <p>
                  Monday-Thursday 7am-7pm <br /> Friday 9am-5pm
                </p>
              </div>
              <div className="flex flex-col">
                <h1 className="text-xl lg:text-[28px] text-primary font-bold mb-3">
                  Phone
                </h1>
                <a href="tel:+19073764880">907-376-4880</a>
                <p> Referral Fax Line 907-376-4885</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EducationalForm;
